import { render, staticRenderFns } from "./DataLog.vue?vue&type=template&id=f9cd48e2&scoped=true&"
import script from "./DataLog.vue?vue&type=script&lang=js&"
export * from "./DataLog.vue?vue&type=script&lang=js&"
import style0 from "./DataLog.vue?vue&type=style&index=0&id=f9cd48e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cd48e2",
  null
  
)

export default component.exports